import { Controller } from "@hotwired/stimulus"

// Handles expand/collapse of inline new task form within a priority group
export default class extends Controller {
  static targets = ["addButton", "form", "titleInput", "formElement"]

  showForm() {
    this.addButtonTarget.classList.add("hidden")
    this.formTarget.classList.remove("hidden")
    this.titleInputTarget.focus()
  }

  hideForm() {
    this.formTarget.classList.add("hidden")
    this.addButtonTarget.classList.remove("hidden")
    this.formElementTarget.reset()
  }

  handleKeydown(event) {
    if (event.key === "Escape") {
      event.preventDefault()
      this.hideForm()
    }
  }
}
